import { render, staticRenderFns } from "./LifecycleReports.vue?vue&type=template&id=0c68b6bf"
import script from "./LifecycleReports.vue?vue&type=script&lang=js"
export * from "./LifecycleReports.vue?vue&type=script&lang=js"
import style0 from "./LifecycleReports.vue?vue&type=style&index=0&id=0c68b6bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports